import React from 'react';
import { useTheme } from 'styled-components';
import { IDiscountState } from './useDiscountEditing';
import { RoundPrice } from '../../../logic/Utility/CalculationUtilities';
import { CropKey } from './CompetitiveAllowanceMain';

export function PlanDiscountSummaryRow(props: {
	planName: string;
	discountState: IDiscountState;
	cornExists: boolean;
	soyExists: boolean;
}) 
{
	const theme = useTheme();
	const { planName, discountState, cornExists, soyExists } = props;
	const cropDiscounts = (['Corn', 'Soybean'] as CropKey[]).map((cropKey) => 
	{
		const totalCropLevelDiscount = discountState.discounts?.[cropKey].crop.reduce((acc, item) => acc + (item.PerBagDiscount || 0), 0) || 0;
		const averagePricePerBag = RoundPrice(discountState.discounts?.[cropKey].hybrids.flatMap(h => h.Products).reduce((acc, product) => acc + (product.PricePerBag * product.Quantity), 0) /
			discountState.discounts?.[cropKey].hybrids.flatMap(h => h.Products).reduce((acc, product) => acc + product.Quantity, 0) || 0);
		const totalMsrp = discountState.discounts?.[cropKey].hybrids.flatMap(h => h.Products).reduce((acc, product) => acc + (product.PricePerBag * product.Quantity), 0) || 0;
		const totalDiscount = discountState.discounts?.[cropKey].hybrids.flatMap(h => h.Products.map(p => (totalCropLevelDiscount + h.PerBagDiscount) * p.Quantity)).reduce((acc, val) => acc + val, 0) || 0;
		const totalPriceAfterDiscount = totalMsrp - totalDiscount;

		return {
			cropKey,
			averagePricePerBag,
			totalCropLevelDiscount,
			totalMsrp,
			totalDiscount,
			totalPriceAfterDiscount
		};
	});

	const totalDiscounts = cropDiscounts.reduce((acc, curr) => 
	{
		acc.totalCropLevelDiscount += curr.totalCropLevelDiscount;
		acc.totalMsrp += curr.totalMsrp;
		acc.totalDiscount += curr.totalDiscount;
		acc.totalPriceAfterDiscount += curr.totalPriceAfterDiscount;
		return acc;
	}, {
		totalCropLevelDiscount: 0,
		totalMsrp: 0,
		totalDiscount: 0,
		totalPriceAfterDiscount: 0
	});


	return <div className='CompetitiveAllowance_SummaryTable' style={{ display: 'flex', alignItems: 'start', height: 'auto', marginTop: 25 }}>
		<div
			style={{
				backgroundColor: theme.colors.primary,
				color: theme.colors.white,
				width: '100%',
				borderRadius: 4,
				paddingTop: 10,
				paddingBottom: 10,
				paddingRight: 15,
				paddingLeft: 15,
				display: 'flex',
				fontWeight: theme.fontWeights.bold
			}}
		>
			<div style={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
				<div style={{ fontSize: theme.fontSizes.extraSmall }}>Name</div>
				<div>{planName}</div>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right', width: '11%', visibility: cornExists ? 'visible' : 'hidden' }}>
				<div style={{ fontSize: theme.fontSizes.extraSmall }}>Corn/Unit</div>
				<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cropDiscounts.find(cd => cd.cropKey === 'Corn')?.averagePricePerBag)}</div>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right', width: '8%', visibility: soyExists ? 'visible' : 'hidden' }}>
				<div style={{ fontSize: theme.fontSizes.extraSmall }}>Soy/Unit</div>
				<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cropDiscounts.find(cd => cd.cropKey === 'Soybean')?.averagePricePerBag)}</div>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right', width: '10%' }}>
				<div style={{ fontSize: theme.fontSizes.extraSmall }}>Subtotal</div>
				<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalDiscounts.totalMsrp)}</div>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right', width: '50%' }}>
				<div style={{ fontSize: theme.fontSizes.extraSmall }}>Total Discount</div>
				<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalDiscounts.totalDiscount)}</div>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right', width: '10%' }}>
				<div style={{ fontSize: theme.fontSizes.extraSmall }}>Total</div>
				<div>{Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(totalDiscounts.totalPriceAfterDiscount)}</div>
			</div>
		</div>
	</div>;
}
